import { render } from "./App.vue?vue&type=template&id=416146c5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=416146c5&lang=css"

import exportComponent from "F:\\myArtWorksIn3D\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__